import { useTranslation } from 'react-i18next';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

interface InvalidNameProps {
  setShowInvalidNameError: (show: boolean) => void;
  showInvalidNameError: boolean;
}

const InvalidName: React.FC<InvalidNameProps> = ({
  setShowInvalidNameError,
  showInvalidNameError,
}) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      bodyText={t('InvalidPlanName.paragraphText')}
      headerText={t('InvalidPlanName.errorHeader')}
      isError={true}
      isOpen={showInvalidNameError}
      onClose={() => setShowInvalidNameError(false)}
      primaryButtonHandler={() => setShowInvalidNameError(false)}
      primaryButtonText={t('Button.close')}
    />
  );
};

export default InvalidName;
